<hb-modal-dialog heading="{{'DirtyFormDialog.Confirm' | i18next}}" [showFooter]="false" id="dirtyFormDialog">
  <div content>{{'DirtyFormDialog.YouHaveModifiedThisItem' | i18next}} {{ dataIsValid ? dataValidMessage : dataInvalidMessage }}</div>
  <div footerContent>
    <button type="button" class="btn btn-primary" (click)="submit(false, true)" [disabled]="!dataIsValid" id="modalSave">{{'DirtyFormDialog.Save' | i18next}}</button>
    <button type="button" class="btn btn-default" (click)="submit(true, false)" id="modalDiscard">{{'DirtyFormDialog.DiscardChanges' | i18next}}</button>
    <button type="button" class="btn btn-default" (click)="submit(false)" id="modalCancel">{{'DirtyFormDialog.Cancel' | i18next}}</button>
  </div>
</hb-modal-dialog>
